<template>
  <div>
    <div class="singlePho">
      <i class="iconfont icon-shibai-icon"></i>
    </div>
    <p class="result">验证失败</p>
    <div class="listsDetail"></div>
    <div class="btn">
      <a
        href="javascript:;"
        class="weui-btn weui-btn_warn btn-spec"
        able="true"
        id="reEvaluate"
        style="display:block"
        @click="TofillInfc"
      >重新填写</a>
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import service from '@/request/api'; // 导入api接口
import ServerBank from '@/components/ServerBank.vue';
import { Toast } from 'vant';
import { checkStatus } from './mixin';

export default {
  name: 'IdentifyUploadFailure',
  components: {
    ServerBank,
  },
  data() {
    return {
      danger: 'danger',
    };
  },
  mixins: [checkStatus],
  methods: {
    TofillInfc() {
      service.CommonForms.rewriteWhenFailure({
        orderId: localStorage.getItem('orderId'),
      }).then((res) => {
        if (res.success) {
          if (res.data) {
            localStorage.setItem('orderId', res.data.orderId);
            this.$store.dispatch('commonForms/jumpMetthod', {
              orderId: res.data.orderId,
            });
          }
        } else {
          Toast('重新填写失败');
        }
      });
    },
  },
};
</script>
<style scoped>
.mark {
  width: 0.6rem;
  height: 0.6rem;
  margin: 1.03rem auto 0.2rem;
}
.mark i {
  color: #f55348;
  font-size: 0.6rem;
}
.warn {
  color: #1c2438;
  font-size: 0.17rem;
  font-size: 700;
  text-align: center;
}
.tip {
  width: 3.45rem;
  height: 0.6rem;
  margin: 0 auto;
  margin-top: 0.08rem;
  color: #9ea7b4;
  font-size: 0.14rem;
  text-align: center;
}
.shell {
  padding-right: 20px;
  padding-left: 20px;
}

.btn {
  margin-top: 25px;
  margin-bottom: 25px;
}
.singlePho {
  width: 100%;
  padding-top: 128px;
}
.singlePho i {
  margin-top: 69px;
  color: #f5514a;
  font-size: 67px;
}
.result {
  color: #1c2438;
  font-weight: 700;
  font-size: 19px;
  text-align: center;
}
a {
  display: block;
  height: 50px;
  margin-top: 70px;
  color: #fff;
  font-size: 18px;
  line-height: 50px;
  background-color: #e64340;
  border-radius: 11px;
}
.lists {
  margin-top: 0.08rem;
  color: #9ea7b4;
  font-size: 0.14rem;
  text-align: center;
}
.listsDetail {
  padding-right: 0.15rem;
  padding-left: 0.15rem;
}
.listsDetail p {
  color: #9ea7b4;
  font-size: 0.14rem;
  text-align: center;
}
.special {
  background-color: #b2b2b2 !important;
}
</style>
